// APP-132327 This is to handle the different formats that openAI (reasoning models) and Gemini send back content
export function hasStringContent (content) {
    if (typeof content === 'string') {
        return content.trim().length > 0;
    }

    // Arrays and all other types (null, undefined, etc.) are considered "no string content"
    // Arrays represent structured content from different AI providers that should be handled as tool calls
    return false;
}

export function isUserMessage (message) {
    return message.type === 'user';
}

export function isAssistantMessage (message) {
    return message.type === 'assistant' && !isToolCall(message);
}

export function hasToolCalls (message) {
    return message.type === 'assistant' && message.tool_calls?.length > 0;
}

export function isToolCall (message) {
    return hasToolCalls(message) && !hasStringContent(message.content);
}

export function isToolCallArgumentStream (message) {
    if (!Array.isArray(message.content)) return false;

    const hasFunctionCallContent = message.content.find((el) => el.type === 'function_call');
    const hasToolCalls = message.tool_calls?.length > 0;

    return hasFunctionCallContent && !hasToolCalls;
}

export function isToolResponse (message) {
    return message.type === 'tool';
}

export function isProgressMessage (message) {
    return message.type === 'progress';
}

export function isNextActionsProgress (message) {
    return message.type === 'progress' && message.metadata?.isNextActions === true;
}

export function isErrorMessage (message) {
    return message.type === 'error';
}

export function isCustomInstructionsMessage (message) {
    return message.type === 'custom_instructions';
}

export function isSubagentCall (message) {
    return message.metadata?.subagent_call === true;
}

export function isSubagentHandoff (message) {
    return isToolResponse(message) && message.metadata?.subagent_handoff === true;
}

export function hasReasoningSummaries (message) {
    if (message?.type === 'assistant' && Array.isArray(message.content)) {
        const reasoningBlock = message.content.find((el) => el.type === 'reasoning');
        if (!reasoningBlock) return false;

        return reasoningBlock.summary.length > 0;
    }

    return false;
}
